/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { reserveSchema } from "./reserveSchema.ts";

export const orgUnitReserveListPathOrgUnitIdSchema = z.uuid();

export const orgUnitReserveListStatus200Schema = z.array(reserveSchema);

export const orgUnitReserveListResponseSchema = orgUnitReserveListStatus200Schema;
